import React from 'react';
import PropTypes from 'prop-types';
import { getUrl, getDescText, getPageYear } from '../../common/services/builders';


var preString = window.location.pathname; 

preString = preString.replace("/home.aspx", "");

if (preString.includes(".aspx"))
{
  preString = preString.substring(0, preString.lastIndexOf(".aspx"));
}

if (preString.endsWith('#/'))
{
  preString = preString.replace("#/", "");
}



function TWIINListingCard({ entry, settings }) {

    const getTAPSLink = () => {

        var link = `${preString}/${entry.sys.slug}`;
        var linkText = entry.title && entry.title.length < 90 ? entry.title : entry.title.substr(0, 90).trim() + '...';
        var headerLink='';
  
  
          headerLink = <a href={link}>{linkText}</a>;

      return headerLink
  
      }

    const truncateText = (text) => {
        if (text.length <= 90) {
          return text;
        } else {
          const truncatedText = text.substr(0, 90);
          const lastSpaceIndex = truncatedText.lastIndexOf(" ");
          if (lastSpaceIndex === -1) {
            return truncatedText + "...";
          } else {
            return truncatedText.substr(0, lastSpaceIndex) + "...";
          }
        }
      };

    const getTAPSDescription = () => {

        var descriptionPlaintext = entry.richText ? entry.richText.replace(/<\/?([a-z][a-z0-9]*)\b[^>]*>?/gi, ''): "";

        var description = descriptionPlaintext != "" && descriptionPlaintext.length < 90 ? descriptionPlaintext : truncateText(descriptionPlaintext);

        return description;


    }


    return (
        <div className="column large-3">       
            <article className="ui-card" style={{ minHeight: 460 + "px" }}>

                <div className="ui-card__image">
                    <div className="ui-card__image-container" style={renderThumbnailImage(settings, entry)}></div>
                </div>

                <div className="ui-card__type">TAPS</div>

                <div className="ui-card__content">
                    <h3 className="ui-card__heading">{getTAPSLink(entry, settings)}</h3>
                    <p className="ui-card__text">{getTAPSDescription()}</p>
                    <span className="ui-card__date">{getDatePosted(entry)}</span>
                </div>
                
            </article>
      </div>
    );
    
}

function renderThumbnailImage(settings, entry){
    let thumbnailImage = {backgroundImage: `url(/site-elements/images/hero/hero-slider-1.jpg&w=266)`};

    if (entry.image) {
        thumbnailImage  = {backgroundImage: `url(https://preview-twi.cloud.contensis.com${entry.image.asset.sys.uri}?w=266)`};
    }
    return thumbnailImage;


}

function getDatePosted(entry)
{
    if (entry && entry.datePosted)
    {
        let datePosted = new Date(entry.datePosted);
	    return `${day[datePosted.getDay()]}, ${datePosted.getDate()} ${shortMonth[datePosted.getMonth()]} ${datePosted.getFullYear()}`; 

    }

}

function ListingCard({ entry, settings }) {

    const [showNonMemberModal, setNonMemberModal] = useState(false);
    const [showTrialExpiredModal, setTrialExpiredModal] = useState(false);
}

 

TWIINListingCard.propTypes = {
    entry: PropTypes.object,
    search: PropTypes.object,
    filters: PropTypes.object,
    settings: PropTypes.object,
};

export default TWIINListingCard;